import { get, post, put, postFile, putFile, deleteById } from './api';

export const productAPI = {
  getProducts() {
    return get('admin/product');
  },

  getProductCategories() {
    return get('admin/product/categories');
  },

  addProduct(ingredientData) {
    return postFile('admin/product', ingredientData);
  },

  updateProduct(ingredientData) {
    return putFile('admin/product', ingredientData);
  },

  deleteProduct(id) {
    return deleteById('admin/product', id);
  },

  getDislikedProducts() {
    return get('admin/disliked-product');
  },

  findDislikedProductsIngredients(id) {
    return post('admin/disliked-product/find-ingredients', { id });
  },

  addDislikedProductIngredient(ingredientData) {
    return post('admin/disliked-product/ingredient', ingredientData);
  },

  deleteDislikedProductIngredient(ingredientData) {
    return put('admin/disliked-product/ingredient/delete', ingredientData);
  },

  addDislikedProduct(productData) {
    return post('admin/disliked-product', productData);
  },

  deleteDislikedProduct(id) {
    return deleteById('admin/disliked-product', id);
  },

  updateDislikedProduct(productData) {
    return put('admin/disliked-product', productData);
  },

  getSuggestedProducts() {
    return get('admin/suggested-product');
  },

  addSuggestedProduct(productData) {
    return postFile('admin/suggested-product', productData);
  },

  updateSuggestedProduct(productData) {
    return putFile('admin/suggested-product', productData);
  },

  deleteSuggestedProduct(id) {
    return deleteById('admin/suggested-product', id);
  },
};
